var _polyline, _polygon, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "copy",
    viewBox: "0 0 640 640",
    fill: "none",
    stroke: "#666",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "162.8,131.8 162.8,38 439.6,38 593,174.9 593,545.4 490.9,545.4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "490.9,230.5 490.9,601 47.7,600.7 47.7,131.8 383.5,131.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 117.4,
    y1: 267.3,
    x2: 341.3,
    y2: 267.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 279.4,
    y1: 445.5,
    x2: 116.7,
    y2: 445.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 116.9,
    y1: 356,
    x2: 400.4,
    y2: 356
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3d088bf7d0882aaa44e608de8061ef17.svg";
export { ForwardRef as ReactComponent };